import { IDashboardContext } from "../../../contexts/dashboard-context";

export function isPhotoTransformSupported(
	zone: eXpress.core.IZone | undefined,
	dashboard: IDashboardContext,
) {
	return dashboard.canPanPhoto(zone) && dashboard.canZoomPhoto(zone);
}
